<template>
  <div class="my-account" @scroll="handleScroll">
    <div class="header">
      <TopBar :title ="title" />
    </div>
    <div class="content">
      <van-tabs type="card" color="#FBC260" v-if="$route.query.title == 1" @click="onClick">
        <van-tab :title="$t('mine.shouru')">
          <div class="flex-center" v-if="loading1">
            <van-loading size="35" />
          </div>
          <div v-else>
            <div v-if="list.length>0">
              <div class="card" v-for="(item,index) of list" :key="index">
                <div class="left">
                  <div class="div-1">{{ item.description }}</div>
                  <div class="div-2">{{$t("mine.date")}}：{{ item.dateline }}</div>
                  <div class="div-3">{{$t("mine.type")}}：{{ item.category }}</div>
                </div>
                <div class="right">
                  +{{ item.quantity }}
                </div>
              </div>
            </div>
            <div v-else class="flex-center">
              <van-image
                width="100"
                height="100"
                :src="nodataImg"
              />
            </div>
          </div>

          <div style="text-align:center; opacity: 0;" v-if="list.length !== 0">
            <van-button  type="primary" size="small">{{ $t("getMore") }}...</van-button> 
          </div>
        </van-tab>
        <van-tab :title="$t('mine.zhichu')">
          <div class="flex-center" v-if="loading2">
            <van-loading size="35" />
          </div>
          <div v-else>
            <div v-if="list2.length>0">
              <div class="card" v-for="(item,index) of list2" :key="index">
                <div class="left">
                  <div class="div-1">{{ item.description }}</div>
                  <div class="div-2">{{$t("mine.date")}}：{{ item.dateline }}</div>
                  <div class="div-3">{{$t("mine.type")}}：{{ item.category }}</div>
                </div>
                <div class="right">
                  -{{ item.quantity }}
                </div>
              </div>
            </div>
            <div v-else class="flex-center">
              <van-image
                width="100"
                height="100"
                :src="nodataImg"
              />
            </div>
          </div>
          <div style="text-align:center;opacity: 0;" v-if="list2.length !== 0">
            <van-button  type="primary" size="small">{{ $t("getMore") }}...</van-button> 
          </div>
        </van-tab>
      </van-tabs>
      <div v-else class="xinyong-class">
        <div class="flex-center" v-if="loading3">
          <van-loading size="35" />
        </div>
        <div v-else>
          <div v-if="creditsList.length>0">
            <div class="card" v-for="(item,index) of creditsList" :key="index">
              <div class="left">
                <div class="div-1">{{item.description}}</div>
                <div class="div-2">{{$t("mine.date")}}：{{ item.dateline }}</div>
                <div class="div-3">{{$t("mine.type")}}：{{ item.type }}</div>
              </div>
              <div class="right">
                {{item.type === '增加' ? '+' :'-'}} {{ item.quantity }}
              </div>
            </div>
          </div>
          <div v-else class="flex-center">
              <van-image
                width="100"
                height="100"
                :src="nodataImg"
              />
            </div>
        </div>

        <div style="text-align:center;opacity: 0;" v-if="creditsList.length !== 0">
          <van-button type="primary" size="small">{{ $t("getMore") }}...</van-button> 
        </div>
      </div>
      <div class="finished-text" v-show="pagebar.currentPage>=pagebar.totalPage">
        <div class="finished-text__line"></div>
        <span class="finished-text__text">{{ $t("baseline") }}</span>
      </div>
    </div>
  </div>
</template>

<script>
  import { accountsPoints, accountsCredits} from '@/api/api.js';
  import { Notify } from 'vant';
  import TopBar from '@/common/top-bar/index.vue'
  import img from '@/assets/img/无数据.png'
  import { throttle } from 'lodash'

  export default {
    name: 'MyAccount',
    components: {
      TopBar
    },
    data () {
      return {
        nodataImg:img,
        loading1:true,
        loading2:true,
        loading3:true,
        title:"",
        list:[],
        list2:[],
        creditsList:[],
        pagebar:{
          currentPage:1,
          pageSize:15,
          totalPage:2,
          totalSize: 0
        },
        defaultIndexTab:0
      }
    },
    methods: {
      onClick(value){
        this.defaultIndexTab = value;
        if(value === 0){
          this.initPage(1)
        }else{
          this.initPage(2)
        }
      },

      onClickLeft(){
        this.$router.go(-1)
      },
      confirm(){},

      initPage(flag){
        const loginInfo = JSON.parse(localStorage.getItem('LOGIN_INFO'));
        const params = {
          id:loginInfo.id,
          page:1,
          size: 15,
        }
        if(this.$route.query.title == 1){
          accountsPoints(Object.assign(params,{changeType:flag})).then(res=>{
            if (res.code === 200) {
              if(flag === 1){
                this.list = res.data.list;
                setTimeout(()=>{
                  this.loading1 = false
                },200)
              }else{
                this.list2 = res.data.list;
                setTimeout(()=>{
                  this.loading2 = false
                },200)
              }
              this.pagebar = res.data.pagebar;
            }else{
              Notify({ type: 'danger', message: res.errors[0] });
            }
          })
        }else{
          accountsCredits(params).then(res=>{
            if (res.code === 200) {
              console.log(res);
              this.creditsList = res.data.list;
              this.pagebar = res.data.pagebar;
              setTimeout(()=>{
                this.loading3 = false
              },2000)
            }else{
              Notify({ type: 'danger', message: res.errors[0] });
            }
          })
        }
      },

      // handleScroll(e) {
      //   if (e.target.scrollTop + e.target.clientHeight >= e.target.scrollHeight) {
      //     this.getMore(this.defaultIndexTab +1);
      //   }
      // },

      getMore(flag){
        const loginInfo = JSON.parse(localStorage.getItem('LOGIN_INFO'));
        const params = {
          id:loginInfo.id,
          page:this.pagebar.currentPage +1,
          size: this.pagebar.pageSize
        }

        if(this.$route.query.title == 1){
          accountsPoints(Object.assign(params,{changeType:flag})).then(res=>{
            if (res.code === 200) {
              if(flag === 1){
                this.list = [...this.list,...res.data.list];
              }else{
                this.list2 = [...this.list2,...res.data.list];
              }
              this.pagebar = res.data.pagebar;
            }else{
              this.pagebar.currentPage --;
              Notify({ type: 'danger', message: res.errors[0] });
            }
          })
        }else{
          accountsCredits(params).then(res=>{
            if (res.code === 200) {
              this.creditsList = [...this.creditsList,...res.data.list];
              this.pagebar = res.data.pagebar;
            }else{
              this.pagebar.currentPage --;
              Notify({ type: 'danger', message: res.errors[0] });
            }
          })
        }
      },

      handleScroll: throttle(function(e) {
        const scrollTop = document.querySelector(".my-account").scrollTop;
        const clientHeight = document.querySelector(".my-account").clientHeight;
        const scrollview = document.querySelector('.my-account').scrollHeight;
        if (scrollTop + clientHeight >= scrollview - 100) {
            this.getMore(this.defaultIndexTab +1);
          }
        },500)
    },
    mounted () {
      // window.addEventListener('scroll', this.handleScroll, true);
      if(this.$route.query.title == 1){
        this.title = this.$t("mine.account")
      }else{
        this.title = this.$t("mine.xinyong")
      }
      this.initPage(1);
    },
    destroyed() {
      window.removeEventListener('scroll', this.handleScroll);
    },
    activated () {
    }
  }
</script>

<style lang="stylus" scoped>
  /deep/.my-account{
    width: 100%;
    height: 100%;
    overflow: scroll;
    overflow-x: hidden;
    // background-color: #F3F3F3;
    .header{
    }
    .content{
      padding: .4rem;
      .van-tabs.van-tabs--card{
        .van-tabs__wrap{
          border-top-left-radius: 10px;
          border-bottom-left-radius: 10px;
          .van-tabs__nav{
            border-top-left-radius: 10px;
            border-bottom-left-radius: 10px;
            border-top-right-radius: 10px;
            border-bottom-right-radius: 10px;
            .van-tab:nth-child(1){
              border-top-left-radius: 10px;
              border-bottom-left-radius: 10px;
            }
            .van-tab:nth-child(2){
              border-top-right-radius: 10px;
              border-bottom-right-radius: 10px;
            }
          }
        }

        .van-tab__pane{
          padding: .4rem;
          margin-top:.2rem;
          .card{
            display: flex;
            justify-content:space-between;
            align-items: center;
            font-size: 14px;
            margin-bottom:.6rem;
            padding-bottom: .2rem;
            border-bottom: 1px solid #D8D8D8;
            .left{
              width: 80%;
              .div-1{
                color: #57A8E5;
                line-height: .4rem;
              }
              .div-2{
                margin: .2rem 0;
              }
            }
            .right{
              font-size: 14px;
              color: green;
            }
          }
        }
      }
      .xinyong-class{
        .card{
          display: flex;
          justify-content:space-between;
          align-items: center;
          font-size: 14px;
          margin-bottom:.6rem;
          padding-bottom: .2rem;
          border-bottom: 1px solid #D8D8D8;
          .left{
            width: 80%;
            .div-1{
              color: #57A8E5;
              line-height: .4rem;
            }
            .div-2{
              margin: .2rem 0;
            }
          }
          .right{
            font-size: 14px;
            color: green;
          }
        }
      }
    }
  }

  .flex-center{
    hight: 100%;
    display flex;
    justify-content center;
  }
</style>



// WEBPACK FOOTER //
// src/pages/my-account/MyAccount.vue